import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Dialog, DialogContent, DialogTitle } from 'base-ui'

import { ProductBuyBoxSocialPopupModalCopyLink } from './ProductBuyBoxSocialPopupModalCopyLink'
import { ProductBuyBoxSocialPopupModalIcons } from './ProductBuyBoxSocialPopupModalIcons'

const ProductBuyBoxSocialPopupModal: FC<{
  handleClose: () => void
  isOpen: boolean
}> = ({ handleClose, isOpen }) => {
  return (
    <Dialog
      onClose={handleClose}
      open={isOpen}
      slotProps={{
        dialog: {
          className: 'tablet:w-3/4 tablet:max-w-lg',
        },
      }}
    >
      <DialogTitle onClose={handleClose}>
        <FormattedMessage id="socialModal.label.title" />
      </DialogTitle>
      <DialogContent>
        <ProductBuyBoxSocialPopupModalIcons />
        <ProductBuyBoxSocialPopupModalCopyLink />
      </DialogContent>
    </Dialog>
  )
}

export { ProductBuyBoxSocialPopupModal }
